// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".eopoi-widget .tour_description_tabs___wrapper .v-slide-group__wrapper{overflow-x:scroll!important}.eopoi-widget .tour_description_tabs___wrapper .v-tabs-items .tab-title:after{content:\":\"}.eopoi-widget .tour_description_tabs___wrapper .v-tabs-slider-wrapper:first-child{width:100%}.eopoi-widget .tour_description_tabs___wrapper .v-tabs-slider-wrapper:first-child .v-tabs-slider{background-color:#e6eeef!important;border-color:#e6eeef!important;height:10px}", ""]);
// Exports
module.exports = exports;
